


















































































import { Component, Vue } from 'vue-property-decorator';
import { LocationDetailsModule } from '@/store/modules/locationDetails'
import JourneyTemplateDto from '@/models/JourneyTemplates/JourneyTemplateDto';
import JourneyTemplateCreate from '@/components/JourneyTemplates/JourneyTemplateCreate.vue';
import JourneyTemplateEdit from '@/components/JourneyTemplates/JourneyTemplateEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'JourneyTemplatesMasterDetails',
  components: { JourneyTemplateCreate, JourneyTemplateEdit }
})
export default class extends GiganautVue {

    async created() {
        await  LocationDetailsModule.getJourneyTemplates();
    }

    async updateCurrentJourneyTemplate(journeyTemplate: JourneyTemplateDto) {
        await LocationDetailsModule.updateCurrentJourneyTemplate(journeyTemplate);
    }

    get currentJourneyTemplate() {
        return LocationDetailsModule.currentJourneyTemplate;
    }

    get loadingJourneyTemplates() {
        return LocationDetailsModule.loadingJourneyTemplates;
    }

    get journeyTemplates() {
        return LocationDetailsModule.journeyTemplates;
    }
}
